export default function parseJson(json) {
  try {
    return JSON.parse(json);
  } catch (error) {
    console.warn(error);
    return undefined;
  }
}
